export function getAssetUrl(asset: string) {
  if (/^https?:\/\//.test(asset)) {
    return asset;
  }
  return asset.startsWith('/') ? asset : `/${asset}`;
}
